import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-upload',
  templateUrl: './video-upload.component.html',
  styleUrls: ['./video-upload.component.scss']
})
export class AtwVideoUploadAdmin implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
